import React from "react";
import { Box, FlexBox, Typography } from "@vp/swan";
import { RawPrice, PricePerUnit } from "@vp/vp-tokenized-fragment";
import styled from "styled-components";
const InfoTextStyle = styled.div `
  color: var(--swan-sem-color-text-info);
`;
export const WideQuantityListPrice = ({ choice, locale, fractionDigits, currency, }) => {
    return (React.createElement(FlexBox, { alignItems: "baseline" },
        React.createElement(Box, { paddingRight: "3" }, Boolean(choice.totalListPrice &&
            choice.totalDiscountedPrice &&
            choice.totalListPrice > 0 &&
            choice.totalDiscountedPrice > 0) && (React.createElement(RawPrice, { pricingInfo: {
                listPrice: choice.totalListPrice,
                discountPrice: choice.totalDiscountedPrice,
                culture: locale,
                currency,
                minimumFractionDigits: fractionDigits,
                vatInc: true,
                hideVatMessage: true,
                hideShippingMessageInVatMessage: true,
            }, placeHolderText: "", tenant: "vistaprint" }))),
        React.createElement(Typography, { fontSize: "xsmall" },
            React.createElement(InfoTextStyle, null,
                React.createElement(PricePerUnit, { pricingInfo: {
                        unitListPrice: choice.unitDiscountedPrice ?? 0, // We do not want to show cross out unit pricing
                        unitDiscountPrice: choice.unitDiscountedPrice ?? 0,
                        culture: locale,
                        currency,
                        minimumFractionDigits: fractionDigits,
                        vatInc: true,
                        hideVatMessage: true,
                        hideShippingMessageInVatMessage: true,
                    }, placeHolderText: "", tenant: "vistaprint" })))));
};
//# sourceMappingURL=wide-quantity-list-price.js.map